import { awaitRequests, promise } from '../../../helpers';
import { getGroupsParticipantsItem } from '../groups-participants';
import { upsertScheduleForAssignment } from '../schedules';

const addLiveClass = ({ data }) => {
    return (dispatch, getState, getFirebase) => {
        // -- add
        const add = d => {
            return getFirebase()
                .firestore()
                .collection('liveClasses')
                .add(d)
                .then(docRef => promise({ ...d, id: docRef.id }));
        };

        // after add
        const afterAdd = async item => {
            const reqs = [];

            if (item.groupId) {
                const requestParticipants = await dispatch(
                    getGroupsParticipantsItem({ where: [['groupId', '==', item.groupId]] }),
                );
                if (requestParticipants.participantsIds) {
                    reqs.push(dispatch(upsertScheduleForAssignment(item, requestParticipants.participantsIds, 'live-class')));
                }
            }

            return awaitRequests(reqs).then(() => promise(item));
        };

        // --
        if (data) {
            return add(data).then(item => afterAdd(item));
        }

        return promise();
    };
};

export default addLiveClass;
